import { createPortal } from 'react-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { InlineNotification } from '@carbon/react';

import { useAvailableNotifications } from 'core/notifications';
import styles from 'theme/features/layout/notifications.module.scss';

const TRANSITION_DURATION = Number(styles.duration);

const Notifications = () => {
  const { notifications, remove } = useAvailableNotifications();

  return createPortal(
    <div className={styles.notifications}>
      <TransitionGroup>
        {notifications.map((x) => (
          <CSSTransition
            key={x.id}
            timeout={TRANSITION_DURATION}
            classNames={{
              enter: styles['notification-enter'],
              enterActive: styles['notification-enter-active'],
              exit: styles['notification-exit'],
              exitActive: styles['notification-exit-active']
            }}
          >
            <InlineNotification
              title={x.title}
              subtitle={x.description}
              kind={x.type}
              onClose={() => remove(x.id)}
              lowContrast
              className={styles.notification}
            />
          </CSSTransition>
        ))}
      </TransitionGroup>
    </div>,
    document.body
  );
};

export default Notifications;
